// Menú mobile (cajón lateral)
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('[data-menu-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav) return;

  function setOpen(open) {
    nav.hidden = !open;
    toggle.setAttribute('aria-expanded', open);
    document.body.classList.toggle('menu-open', open);
    if (open) {
      var close = nav.querySelector('.bv-drawer__close');
      if (close) close.focus();
    } else {
      toggle.focus();
    }
  }

  toggle.addEventListener('click', function () { setOpen(nav.hidden); });
  nav.querySelectorAll('[data-menu-close]').forEach(function (el) {
    el.addEventListener('click', function () { setOpen(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !nav.hidden) setOpen(false);
  });
});

// Encabezado fijo: sombra y versión compacta al hacer scroll
document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('[data-header]');
  if (!header || !header.classList.contains('bv-header--sticky')) return;
  var ticking = false;
  function update() {
    header.classList.toggle('is-scrolled', window.scrollY > 40);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
});

// Carruseles (categorías y productos destacados)
function initCarousel(root) {
  if (root.dataset.carouselReady) return;
  root.dataset.carouselReady = 'true';
  var track = root.querySelector('[data-carousel-track]');
  if (!track) return;
  var prev = root.querySelectorAll('[data-carousel-prev]');
  var next = root.querySelectorAll('[data-carousel-next]');
  var bar = root.querySelector('[data-carousel-progress]');

  function step() {
    var item = track.firstElementChild;
    if (!item) return track.clientWidth;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    var perView = Math.max(1, Math.floor((track.clientWidth + gap) / (item.getBoundingClientRect().width + gap)));
    return perView * (item.getBoundingClientRect().width + gap);
  }
  function update() {
    var max = track.scrollWidth - track.clientWidth;
    root.classList.toggle('is-overflowing', max > 4);
    root.classList.toggle('at-start', track.scrollLeft <= 4);
    root.classList.toggle('at-end', track.scrollLeft >= max - 4);
    prev.forEach(function (b) { b.disabled = track.scrollLeft <= 4; });
    next.forEach(function (b) { b.disabled = track.scrollLeft >= max - 4; });
    if (bar && track.scrollWidth) {
      var ratio = track.clientWidth / track.scrollWidth;
      var pos = max > 0 ? track.scrollLeft / max : 0;
      bar.style.setProperty('--bar', (ratio * 100) + '%');
      bar.style.setProperty('--pos', (pos * (1 / ratio - 1) * 100) + '%');
    }
  }
  function move(dx) {
    var start = track.scrollLeft;
    track.scrollBy({ left: dx, behavior: 'smooth' });
    // Si el navegador no animó (pestaña en segundo plano, etc.), saltar directo
    setTimeout(function () {
      if (Math.abs(track.scrollLeft - start) < 2) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = start + dx;
        track.style.scrollBehavior = '';
        update();
      }
    }, 450);
  }
  prev.forEach(function (b) { b.addEventListener('click', function () { move(-step()); }); });
  next.forEach(function (b) { b.addEventListener('click', function () { move(step()); }); });
  track.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
}

// Banners rotativos de la portada
function initSlider(root) {
  if (root.dataset.sliderReady) return;
  root.dataset.sliderReady = 'true';
  var slides = root.querySelectorAll('[data-slide]');
  var dots = root.querySelectorAll('[data-dot]');
  if (slides.length < 2) return;
  var current = 0;
  var delay = (parseInt(root.dataset.autoplay, 10) || 6) * 1000;
  var timer;

  function go(i) {
    current = (i + slides.length) % slides.length;
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
    dots.forEach(function (d, n) {
      d.classList.toggle('is-active', n === current);
      d.setAttribute('aria-selected', n === current);
    });
  }
  function play() {
    stop();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    timer = setInterval(function () { go(current + 1); }, delay);
  }
  function stop() { clearInterval(timer); }

  dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', play);

  var startX = null;
  root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
  root.addEventListener('touchend', function (e) {
    if (startX === null) return;
    var dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1));
    startX = null;
    play();
  });
  play();
}

// Animación suave al entrar en pantalla
var revealObserver = null;
function initReveal(scope) {
  if (!('IntersectionObserver' in window)) return;
  if (!revealObserver) {
    revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
  }
  var selector = '.bv-cats .bv-head, .bv-rail, .bv-cats__grid, .bv-featured .bv-head, .bv-featured .product-grid, .bv-b2b__box, .bv-story__grid, .bv-news__inner';
  scope.querySelectorAll(selector).forEach(function (el) {
    el.setAttribute('data-reveal', '');
    revealObserver.observe(el);
  });
}

function initScope(scope) {
  scope.querySelectorAll('[data-carousel]').forEach(initCarousel);
  scope.querySelectorAll('[data-slider]').forEach(initSlider);
  initReveal(scope);
}

document.documentElement.classList.add('js-reveal');
document.addEventListener('DOMContentLoaded', function () { initScope(document); });

// Editor de temas de Shopify: reiniciar al editar una sección
document.addEventListener('shopify:section:load', function (e) {
  initScope(e.target);
  e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
});

// Quantity selector
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-quantity]').forEach(function (wrapper) {
    wrapper.querySelectorAll('button[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = wrapper.querySelector('input[type="number"]');
        var step = parseInt(btn.getAttribute('data-step'), 10);
        var current = parseInt(input.value, 10) || 0;
        var min = parseInt(input.min, 10);
        if (isNaN(min)) min = 0;
        var newVal = current + step;
        if (newVal >= min) {
          input.value = newVal;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });
});
// Actualización en tiempo real del precio en el carrito
document.addEventListener('DOMContentLoaded', function () {
  var cartForm = document.querySelector('form[action="/cart"]');
  if (!cartForm) return;

  cartForm.addEventListener('change', function (e) {
    var input = e.target;
    if (input.tagName !== 'INPUT' || input.type !== 'number') return;

    var row = input.closest('tr');
    if (!row) return;

    var unitPrice = parseInt(row.querySelector('[data-unit-price]').getAttribute('data-unit-price'), 10);
    var qty = parseInt(input.value, 10) || 0;
    var lineTotal = row.querySelector('[data-line-total]');
    lineTotal.textContent = formatMoney(unitPrice * qty);

    // Actualizar total del carrito
    var cartTotal = 0;
    cartForm.querySelectorAll('tr').forEach(function (r) {
      var priceEl = r.querySelector('[data-unit-price]');
      var qtyInput = r.querySelector('input[type="number"]');
      if (priceEl && qtyInput) {
        cartTotal += parseInt(priceEl.getAttribute('data-unit-price'), 10) * (parseInt(qtyInput.value, 10) || 0);
      }
    });
    var totalEl = document.querySelector('.cart-summary__total span:last-child');
    if (totalEl) totalEl.textContent = formatMoney(cartTotal);
  });

  function formatMoney(cents) {
    return '$ ' + (cents / 100).toLocaleString('es-AR', { minimumFractionDigits: 2 });
  }
});

// Aviso flotante al agregar al carrito
var bvToastTimer;
function showCartToast(opts) {
  var toast = document.querySelector('.bv-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'bv-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);
  }
  var check = '<svg class="bv-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"></path></svg>';
  var close = '<svg class="bv-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"></path></svg>';
  toast.classList.toggle('bv-toast--error', !!opts.error);
  toast.innerHTML =
    (opts.image ? '<img class="bv-toast__img" src="' + opts.image + '" alt="">' : '') +
    '<div class="bv-toast__text"><b>' + (opts.error ? '' : check) + opts.title + '</b>' + (opts.text ? '<span></span>' : '') + '</div>' +
    (opts.error ? '' : '<a class="bv-btn bv-btn--red" href="/cart">Ver carrito</a>') +
    '<button class="bv-toast__close" type="button" aria-label="Cerrar">' + close + '</button>';
  if (opts.text) toast.querySelector('.bv-toast__text span').textContent = opts.text;
  toast.querySelector('.bv-toast__close').addEventListener('click', function () { toast.classList.remove('is-visible'); });
  void toast.offsetWidth;
  toast.classList.add('is-visible');
  clearTimeout(bvToastTimer);
  bvToastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 5000);
}

function updateCartCount(count) {
  document.querySelectorAll('[data-cart-count]').forEach(function (el) {
    el.textContent = count;
    el.hidden = count === 0;
    el.classList.remove('is-bump');
    void el.offsetWidth;
    el.classList.add('is-bump');
  });
}

// Agregar al carrito sin redirigir (tarjetas de producto)
document.addEventListener('submit', function (e) {
  var form = e.target.closest('.product-card__atc, [data-pdp-form]');
  if (!form) return;
  e.preventDefault();

  var btn = form.querySelector('button[type="submit"]');
  var label = btn.querySelector('span') || btn;
  var originalText = label.innerHTML;
  var card = form.closest('.product-card, [data-pdp]');
  var heading = card && card.querySelector('h3, h1');
  var title = heading ? heading.textContent.trim() : '';
  var img = card && card.querySelector('.product-card__image img, .bv-pdp__slide.is-active');
  label.textContent = 'Agregando...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({
      id: form.querySelector('[name="id"]').value,
      quantity: Math.max(1, parseInt((form.querySelector('input[name="quantity"]') || {}).value, 10) || 1)
    })
  })
  .then(function (r) {
    if (!r.ok) return r.json().then(function (err) { throw err; });
    label.textContent = '✓ Agregado';
    btn.classList.add('is-added');    showCartToast({ title: '¡Agregado al carrito!', text: title, image: img ? img.currentSrc || img.src : '' });
    setTimeout(function () {
      label.innerHTML = originalText;
      btn.classList.remove('is-added');
      btn.disabled = false;
    }, 2000);
    return fetch('/cart.js').then(function (r) { return r.json(); });
  })
  .then(function (cart) {
    if (cart) updateCartCount(cart.item_count);
  })
  .catch(function (err) {
    label.innerHTML = originalText;
    btn.disabled = false;
    showCartToast({ error: true, title: 'No se pudo agregar', text: (err && err.description) || 'Probá de nuevo en unos segundos.' });
  });
});

// Selector de cantidad en tarjetas de producto (− / +)
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-qty-step]');
  if (!btn) return;
  var wrap = btn.closest('[data-card-qty]');
  var input = wrap && wrap.querySelector('input[name="quantity"]');
  if (!input) return;
  var min = parseInt(input.min, 10) || 1;
  var max = parseInt(input.max, 10) || Infinity;
  var next = (parseInt(input.value, 10) || min) + parseInt(btn.getAttribute('data-qty-step'), 10);
  input.value = Math.min(max, Math.max(min, next));
});
document.addEventListener('change', function (e) {
  if (!e.target.matches('[data-card-qty] input[name="quantity"]')) return;
  var input = e.target;
  var min = parseInt(input.min, 10) || 1;
  var max = parseInt(input.max, 10) || Infinity;
  input.value = Math.min(max, Math.max(min, parseInt(input.value, 10) || min));
});

// Galería de imágenes en tarjetas de producto (flechas)
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-card-prev], [data-card-next]');
  if (!btn) return;
  e.preventDefault();
  var gallery = btn.closest('[data-card-gallery]');
  if (!gallery) return;
  var slides = gallery.querySelectorAll('.product-card__slide');
  var dots = gallery.querySelectorAll('.product-card__dots i');
  if (slides.length < 2) return;
  var current = 0;
  slides.forEach(function (s, i) { if (s.classList.contains('is-active')) current = i; });
  var next = (current + (btn.hasAttribute('data-card-next') ? 1 : -1) + slides.length) % slides.length;
  slides.forEach(function (s, i) { s.classList.toggle('is-active', i === next); });
  dots.forEach(function (d, i) { d.classList.toggle('is-active', i === next); });
});

// Colección: ordenar y filtros se aplican al cambiar (el precio, con el botón Aplicar)
document.addEventListener('change', function (e) {
  var form = e.target.closest('[data-collection-filters]');
  if (!form || e.target.type === 'number') return;
  form.submit();
});
// Cerrar el desplegable de filtro al hacer clic afuera
document.addEventListener('click', function (e) {
  document.querySelectorAll('.bv-filter[open]').forEach(function (d) {
    if (!d.contains(e.target)) d.removeAttribute('open');
  });
});

// Carrito: al cambiar la cantidad se actualiza solo
(function () {
  var timer;
  function scheduleUpdate(form) {
    clearTimeout(timer);
    form.classList.add('is-updating');
    timer = setTimeout(function () {
      var btn = form.querySelector('[data-cart-update]');
      if (form.requestSubmit && btn) form.requestSubmit(btn); else if (btn) btn.click();
    }, 700);
  }
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    var form = step && step.closest('[data-cart-form]');
    if (form) scheduleUpdate(form);
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-cart-qty]')) return;
    scheduleUpdate(e.target.closest('[data-cart-form]'));
  });
})();

// Reputación: los números cuentan rápido hasta el valor final al aparecer en pantalla
(function () {
  function parse(text) {
    var m = text.trim().match(/^([^\d]*)([\d.]+(?:,\d+)?)(.*)$/);
    if (!m || m[3].charAt(0) === '/') return null; // "7/7" y textos quedan fijos
    var raw = m[2], decimals = raw.indexOf(',') > -1 ? raw.split(',')[1].length : 0;
    var value = parseFloat(raw.replace(/\./g, '').replace(',', '.'));
    return isNaN(value) ? null : { prefix: m[1], suffix: m[3], value: value, decimals: decimals };
  }
  function format(n, d) { return n.toLocaleString('es-AR', { minimumFractionDigits: d, maximumFractionDigits: d }); }
  function run(el) {
    var p = parse(el.getAttribute('data-count-final'));
    if (!p) return;
    var duration = 1200, start = null;
    function frame(t) {
      if (start === null) start = t;
      var k = Math.min(1, (t - start) / duration);
      var eased = 1 - Math.pow(1 - k, 3); // rápido al principio, frena al final
      el.textContent = p.prefix + format(p.value * eased, p.decimals) + p.suffix;
      if (k < 1) requestAnimationFrame(frame); else el.textContent = el.getAttribute('data-count-final');
    }
    requestAnimationFrame(frame);
  }
  function init(scope) {
    var els = scope.querySelectorAll('.bv-rep__data b');
    if (!els.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        run(e.target);
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) {
      if (el.hasAttribute('data-count-final')) return;
      el.setAttribute('data-count-final', el.textContent.trim());
      if (parse(el.textContent)) io.observe(el);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

// Carrusel de subcategorías: elige, entre varias fotos de la colección, la que mejor
// muestra el producto (fondo blanco y producto grande y centrado) y ajusta cómo se ve.
(function () {
  var S = 24;
  function analyze(img) {
    var c = document.createElement('canvas'); c.width = c.height = S;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.drawImage(img, 0, 0, S, S);
    var d = x.getImageData(0, 0, S, S).data;
    function isWhite(i) { var mx = Math.max(d[i], d[i + 1], d[i + 2]), mn = Math.min(d[i], d[i + 1], d[i + 2]); return d[i + 3] < 20 || (mn > 225 && mx - mn < 22); }
    var border = 0, borderW = 0, fill = 0, cx = 0, cy = 0;
    for (var y = 0; y < S; y++) for (var xx = 0; xx < S; xx++) {
      var i = (y * S + xx) * 4, w = isWhite(i);
      if (y === 0 || y === S - 1 || xx === 0 || xx === S - 1) { border++; if (w) borderW++; }
      if (!w) { fill++; cx += xx; cy += y; }
    }
    var bw = borderW / border, nf = fill / (S * S);
    var dist = fill ? Math.hypot(cx / fill - (S - 1) / 2, cy / fill - (S - 1) / 2) / (S / 2) : 1;
    // Puntaje: fondo limpio + producto que ocupa buena parte del círculo + bien centrado
    var score = bw * 2 + (1 - Math.min(1, Math.abs(nf - 0.55) * 2)) * 1.5 + (1 - Math.min(1, dist)) * 1.5;
    return { white: bw >= 0.7, score: score };
  }
  function loadImage(src) {
    return new Promise(function (res) {
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); }; im.onerror = function () { res(null); };
      im.src = src;
    });
  }
  function pick(img) {
    var list = (img.getAttribute('data-candidates') || '').split('|').filter(Boolean);
    if (!list.length) { try { if (analyze(img).white) img.classList.add('is-white-bg'); } catch (e) {} return; }
    Promise.all(list.map(loadImage)).then(function (ims) {
      var best = null, bestScore = -1;
      ims.forEach(function (im, i) {
        if (!im) return;
        try { var a = analyze(im); if (a.score > bestScore) { bestScore = a.score; best = { src: list[i], white: a.white }; } } catch (e) {}
      });
      if (!best) return;
      img.removeAttribute('srcset'); img.removeAttribute('sizes');
      img.src = best.src;
      img.classList.toggle('is-white-bg', best.white);
    });
  }
  function init(scope) {
    var items = scope.querySelectorAll('.bv-rail__img img');
    if (!items.length) return;
    var run = function (img) { if (img.dataset.bgChecked) return; img.dataset.bgChecked = '1'; pick(img); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); run(e.target); } }); }, { rootMargin: '200px' });
      items.forEach(function (img) { io.observe(img); });
    } else items.forEach(run);
  }
  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

// Página de producto: galería (flechas, miniaturas y deslizar) y cambio de variante
document.querySelectorAll('[data-pdp]').forEach(function (pdp) {
  var slides = pdp.querySelectorAll('.bv-pdp__slide');
  var thumbs = pdp.querySelectorAll('[data-pdp-thumb]');
  var current = 0;
  function go(i) {
    if (!slides.length) return;
    current = (i + slides.length) % slides.length;
    slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === current); });
  }
  pdp.addEventListener('click', function (e) {
    if (e.target.closest('[data-pdp-prev]')) go(current - 1);
    else if (e.target.closest('[data-pdp-next]')) go(current + 1);
    else { var t = e.target.closest('[data-pdp-thumb]'); if (t) go(parseInt(t.getAttribute('data-pdp-thumb'), 10)); }
  });
  var main = pdp.querySelector('.bv-pdp__main'), x0 = null;
  if (main) {
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) go(current + (dx < 0 ? 1 : -1)); x0 = null; });
  }
  var sel = pdp.querySelector('[data-pdp-variant]');
  if (sel) sel.addEventListener('change', function () {
    var o = sel.options[sel.selectedIndex];
    var cur = pdp.querySelector('[data-pdp-current]'); if (cur) cur.textContent = o.getAttribute('data-price');
    var cmp = pdp.querySelector('[data-pdp-compare]'); if (cmp) { cmp.textContent = o.getAttribute('data-compare'); cmp.hidden = !o.getAttribute('data-compare'); }
    var sv = pdp.querySelector('[data-pdp-save]'); if (sv) sv.hidden = !o.getAttribute('data-compare');
  });
});
